import { Component, Input, OnInit } from '@angular/core';
import { IBranch } from 'app/shared/Domains/branch';
import { ICompany } from 'app/shared/Domains/company';
import { IFeeDetailPrint } from 'app/shared/Domains/feeDetailPrint';
import { Configuration } from 'config/config';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IMember } from 'app/shared/Domains/member';
import { IEmailFields } from 'app/shared/Domains/emailFields';
import { DatePipe } from "@angular/common";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppServiceManager } from 'common/services/appServiceManager';

@Component({
	selector: 'app-single-receipt-email',
	templateUrl: './single-receipt-email.component.html',
	styleUrls: ['./single-receipt-email.component.css']
})

export class SingleReceiptEmailComponent implements OnInit {
    public Editor = ClassicEditor;
	@Input() company: ICompany;
	@Input() branch: IBranch;
	@Input() member: IMember;
	fee: IFeeDetailPrint;
    email: IEmailFields = new IEmailFields();
	showEmailSingleReceiptPreview = false;

	constructor(private messageService: MessageService, private appServiceManager: AppServiceManager, private LanguageService: LanguageService, public config: Configuration, private datePipe: DatePipe, private confirmationService: ConfirmationService) { }

	ngOnInit() {
		this.fee = new IFeeDetailPrint();
        this.email = new IEmailFields();
	}

	setLabel(label) {
		return this.LanguageService.GetCurrentLanguage("SingleReceiptEmailComponent", label);
	}

    calculateTotalForSinglePrint(fee, tax, discount,taxType) {
        if(tax === undefined || tax === null) {
            tax = 0;
        }
        if(discount === undefined || discount === null) {
            discount = 0;
        }
        if(taxType === 'WITH_TAX') {
            return (parseInt(fee) + parseInt(tax)) - parseInt(discount);
        }
        else {
            return parseInt(fee) - parseInt(discount);
        }
    }

    openSingleReceiptEmailConfirmation(fee, due) {
        this.showEmailSingleReceiptPreview = true;
        this.fee = fee;
        this.email.to = this.member.email;
        this.email.subject = this.branch.name + ' | ' + 'Invoice Receipt' + ' | ' + 'Invoice Date:' + this.datePipe.transform(new Date(due), 'dd-MMM-yy');
        setTimeout(() => {
            const singleHtmlBody = this.getSingleReceiptEmailBodyHtml();
            this.email.body = '<p><strong>Dear Customer</strong>,</p><p>Following is an invoice receipt of your<i> Gym Fee</i>, The receipt details are as under:</p>' + singleHtmlBody;
        }, 300);
    }

    getSingleReceiptEmailBodyHtml() {
        const printContents = document.getElementById('subscriptionSingleFeeEmail').innerHTML;
        const html = `<html><body>${printContents}</body></html>`;
        return html;
    }

    closeEmailConfirmation() {
        this.showEmailSingleReceiptPreview = false;
    }

    sendInvoiceEmailAsPdf() {
        const htmlToPdf = this.getSingleReceiptEmailBodyHtml();
            this.confirmationService.confirm({
                message: "Are you sure you want to proceed?",
                accept: () => {
                    this.appServiceManager.post('customers/sendEmailWhileInvoicReceiptePrint',
                        {
                            data: htmlToPdf,
                            invoiceDay: this.fee.createdDate,
                            subject: this.email.subject,
                            body: this.email.body,
                            to: this.email.to,
                            company: this.company.name

                        }).subscribe((res) => {
                            this.showEmailSingleReceiptPreview = false;
                            this.messageService.clear();
                            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Attachment Sent Successfully!" });
                        },
                            (error) => {
                                this.showEmailSingleReceiptPreview = false;
                                this.messageService.clear();
                                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                            }
                        )
                }
            });
    }
}